import ParkPassAPI from "../parkpassAxiosConfig";

export const getParkPassUsers = async () => {
  try {
    const response = await ParkPassAPI.get("/v1/users/users/");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateParkPassUser = async (userId, payload) => {
  try {
    const response = await ParkPassAPI.put(`/v1/users/users/${userId}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
